import moment from 'moment'

export const complaintMedia = {
    id: '',
    name: '',
    createdBy: '',
    updatedBy: '',
    createdAt: moment().format('YYYY-MM-DD'),
    updatedAt: moment().format('YYYY-MM-DD'),
}